'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _store = require('../store');

var _store2 = _interopRequireDefault(_store);

var _vuex = require('vuex');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    store: _store2.default,
    data: function data() {
        return {};
    },

    props: ['question'],
    computed: _extends({}, (0, _vuex.mapGetters)(['getActiveCategoryId']), {
        answerClass: function answerClass() {
            return {
                'answer--state-invalid': this.question.valid === false,
                'answer--state-true': this.question.plannedToExecute === true,
                'answer--state-false': this.question.plannedToExecute === false,
                'answer--state-null': this.question.plannedToExecute === undefined || this.question.plannedToExecute === null || this.question.plannedToExecute === ''
            };
        }
    }),
    methods: _extends({}, (0, _vuex.mapActions)(['setSiteUpdates']), {
        setAnswer: function setAnswer(value) {
            var payload = {
                id: this.question.id,
                measure: this.question.measure,
                category: this.question.category,
                plannedToExecute: value
            };
            this.setSiteUpdates(payload);
        }
    })
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib!./~/vue-loader/lib/selector.js?type=script&index=0!./public/js/components/switcher.vue
// module id = ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./public/js/components/switcher.vue
// module chunks = 0